module.exports = __webpack_public_path__ + "img/copywriting.d4af80f1.png";